import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { G_GRAPH__BUTTON__image_asset_select_from_existing } from '../_base/_buttons/G_GRAPH__BUTTON__image_asset_select_from_existing';
import { G_GRAPH__BUTTON__image_clear } from '../_base/_buttons/G_GRAPH__BUTTON__image_clear';
import { G_GRAPH__BUTTON__image_upload } from '../_base/_buttons/G_GRAPH__BUTTON__image_upload';

interface PROPS {
  field: FIELD__image_asset;
}

export function G_BAR__image_asset_actions_right({ field }: PROPS) {
  const { GRID_CELL_SIZE } = CONSTANTS__shared;

  return (
    <div className="flex flex-col justify-start h-full flex-shrink-0" style={{ width: `${GRID_CELL_SIZE}px` }}>
      <G_GRAPH__BUTTON__image_upload {...{ field }} />
      <G_GRAPH__BUTTON__image_asset_select_from_existing {...{ field }} />
      <G_GRAPH__BUTTON__image_clear {...{ field }} />
    </div>
  );
}
